import styles from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    open: React.ComponentState;
}

export const LoginBox = ({ open, children, ...rest }: Props) => {
    return (
        <div data-open={open} className={styles.wrapper} {...rest}>
            <div className={styles.box}>{children}</div>
        </div>
    );
};
